/** @format */

import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import MvnoOperatorSetup, { MvnoOperationSetupCollectionInterface } from '../../interfaces/platform/MvnoOperatorSetup';
import { FormGeneralHelper } from '../../helpers/FormGeneral';

const _ = require('underscore');

export type SimCardMnoTariffLoaderType = {
    callback: () => void;
    filters: Array<Filter>;
    orders: Array<Order>;
};

export interface HeaderCheckBoxSelectListElementPrepaid extends HeaderCheckBoxSelectListElement {
    prepaid: boolean;
}

export class SimCardMnoTariffLoader {
    private itemLoaders: ItemLoaders;

    private mvnoOperatorSetupCollection: MvnoOperationSetupCollectionInterface | null;

    private mvnoOperatorSetupHeaderList: Array<HeaderCheckBoxSelectListElementPrepaid> | null;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
        this.mvnoOperatorSetupCollection = null;
        this.mvnoOperatorSetupHeaderList = null;
    }

    load = (params: SimCardMnoTariffLoaderType): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_operator_setups')),
            'get_mvno_operator_setup_list',
            params.filters,
            params.orders,
            (data: MvnoOperationSetupCollectionInterface): void => {
                this.mvnoOperatorSetupCollection = data;
                params.callback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getCollection = (): MvnoOperationSetupCollectionInterface | null => {
        return this.mvnoOperatorSetupCollection;
    };

    getHeaderList = (): Array<HeaderCheckBoxSelectListElementPrepaid> => {
        if (!this.mvnoOperatorSetupHeaderList) {
            const list: Array<HeaderCheckBoxSelectListElementPrepaid> = [];
            if (!this.mvnoOperatorSetupCollection || this.mvnoOperatorSetupCollection['hydra:totalItems'] === 0) {
                return list;
            }
            this.mvnoOperatorSetupCollection['hydra:member'].map((item: MvnoOperatorSetup) => {
                if (item.typeValue === 'TARIFF') {
                    list.push({ name: item.displayName, value: parseInt(item.constValue), prepaid: item.prepaid });
                }
            });
            this.mvnoOperatorSetupHeaderList = list;
        }
        return this.mvnoOperatorSetupHeaderList;
    };

    getItemById = (setupId: number): MvnoOperatorSetup | null => {
        if (this.mvnoOperatorSetupCollection) {
            return _.find(this.mvnoOperatorSetupCollection?.['hydra:member'], (item: MvnoOperatorSetup) => {
                if (item.typeValue === 'TARIFF') {
                    return parseInt(item.constValue) === setupId;
                }
                return false;
            });
        }
        return null;
    };

    getName = (setupId: number): string | null => {
        const obj = this.getItemById(setupId);
        if (!obj) {
            return null;
        }
        return obj.displayName;
    };
}
